module.exports = __webpack_public_path__ + "assets/img/favicons/apple-icon-57x57.png";